import { apiRequest } from '../api';
import { endpoints } from '../config';
import { RequestMethodEnum } from '../types';
import {
  ActivateAccountData,
  ChangePasswordData,
  ForgotPasswordData,
  LoginData,
  RegisterData,
  ResetPasswordData,
} from './types';

export const activateAccount = async (data: ActivateAccountData) =>
  apiRequest<ActivateAccountData>(
    endpoints.auth.activate,
    RequestMethodEnum.POST,
    { data }
  );

export const changePassword = async (data: ChangePasswordData) =>
  apiRequest<ChangePasswordData>(
    endpoints.auth.changePassword,
    RequestMethodEnum.POST,
    { data }
  );

export const forgotPassword = async (data: ForgotPasswordData) =>
  apiRequest<ForgotPasswordData>(
    endpoints.auth.forgotPassword,
    RequestMethodEnum.POST,
    { data }
  );

export const login = async (data: LoginData) =>
  apiRequest<LoginData>(endpoints.auth.login, RequestMethodEnum.POST, {
    data,
    showSuccessMessage: true,
  });

export const logout = async () =>
  apiRequest<Response>(endpoints.auth.logout, RequestMethodEnum.POST, {});

export const register = async (data: RegisterData) =>
  apiRequest<RegisterData>(endpoints.auth.register, RequestMethodEnum.POST, {
    data,
  });

export const resendActivationLink = async () =>
  apiRequest<Response>(
    endpoints.auth.resendActivation,
    RequestMethodEnum.POST,
    {}
  );

export const resetPassword = async (data: ResetPasswordData) =>
  apiRequest<ResetPasswordData>(
    endpoints.auth.resetPassword,
    RequestMethodEnum.POST,
    { data }
  );
